<template>
  <form class="form" style="padding: 0" @submit="$emit('submit-form', $event)">
    <slot />
  </form>
</template>
